// Research & Development page English translations

export default {
  pageTitle: "Research & Development",
  breadcrumbHome: "Home",
  breadcrumbServices: "Services",
  breadcrumbCurrent: "Research & Development",
  
  // Service links
  customManufacturing: "Custom Manufacturing",
  technicalSupport: "Technical Support",
  afterSalesService: "After-Sales Service",
  qualityAssurance: "Quality Assurance",
  researchDevelopment: "Research & Development",
  globalSupplyChain: "Global Supply Chain",
  
  // Main content
  title: "Innovative Research & Development",
  description1: "At PT Eagle Industry Indonesia, our Research & Development team drives innovation that positions us at the forefront of sealing technology. We invest significantly in R&D to develop advanced solutions that address evolving industry challenges, improve performance, and create new possibilities for our customers across various sectors.",
  description2: "Our R&D approach combines fundamental research with practical application development, ensuring that our innovations are not only technically advanced but also commercially viable and immediately applicable to real-world challenges. We collaborate closely with customers, academic institutions, and industry partners to identify emerging needs and develop solutions that exceed expectations.",
  
  // Focus areas section
  focusTitle: "Our R&D Focus Areas:",
  focusAreas: [
    "Advanced material development for enhanced durability and performance",
    "Seal design optimization for improved efficiency and longevity",
    "Smart sealing solutions with integrated monitoring capabilities",
    "Environmentally friendly sealing technologies",
    "High-temperature and high-pressure application solutions",
    "Lightweight materials for automotive and aerospace applications",
    "Digital simulation and predictive modeling for design validation"
  ],
  
  // Research facilities section
  facilitiesTitle: "Research Facilities:",
  facilitiesDescription: "Our state-of-the-art R&D facilities are equipped with advanced testing equipment, material analysis laboratories, and prototyping capabilities. These resources enable our research team to conduct comprehensive testing under simulated operating conditions, validate new designs, and accelerate development cycles while maintaining rigorous quality standards.",
  
  // Metrics
  innovationPipeline: "Innovation Pipeline",
  innovationPipelineDesc: "Continuous development of next-generation sealing solutions",
  technicalExpertise: "Technical Expertise",
  technicalExpertiseDesc: "Specialized R&D team with diverse engineering backgrounds",
  collaborationNetwork: "Collaboration Network",
  collaborationNetworkDesc: "Partnerships with research institutions and industry leaders",
  technologyTransfer: "Technology Transfer",
  technologyTransferDesc: "Effective integration of research findings into production",
  
  // Development process section
  processTitle: "Development Process:",
  processDescription: "Our product development follows a structured process that begins with market research and needs assessment, followed by concept development, prototyping, testing, and validation. We employ agile development methodologies to accelerate innovation while maintaining thorough testing and quality assurance at each stage of development.",
  
  // Intellectual property section
  ipTitle: "Intellectual Property:",
  ipDescription: "We actively protect our innovations through patents and intellectual property rights, ensuring that our technological advantages benefit our customers. Our patent portfolio includes numerous innovations in sealing technology, material science, and manufacturing processes that provide competitive advantages to our partners.",
  
  // Future research section
  futureTitle: "Future Research Directions:",
  futureDescription: "Looking ahead, our R&D efforts are increasingly focused on sustainable technologies, digitalization of sealing systems, and solutions for emerging applications in renewable energy, electric vehicles, and advanced manufacturing. We are committed to developing sealing technologies that contribute to a more sustainable and efficient industrial future.",
  
  // CTA button
  discussRAndD: "Discuss R&D Collaboration",
  
  // Related services section
  relatedServicesTitle: "Related Services",
  relatedServicesDescription: "Explore our other comprehensive services",
  customManufacturingDesc: "Tailored manufacturing solutions to meet specific customer requirements.",
  qualityAssuranceDesc: "Rigorous quality control processes ensuring international standards compliance.",
  technicalSupportDesc: "Expert technical assistance to ensure optimal product performance.",
  readMore: "Read more"
};